import L from 'leaflet';
import marker_cpt  from './static/Icons/icon_cpt.png'
import marker_cptu from './static/Icons/icon_cptu.png'
import marker_cpte from './static/Icons/icon_cpte.png'
import marker_dmt from './static/Icons/icon_dmt.png'
import marker_sdmt from './static/Icons/icon_sdmt.png'
import marker_sondaggio from './static/Icons/icon_sondaggio.png'
import marker_hvsr from './static/Icons/icon_hvsr.png'
import marker_masw from './static/Icons/icon_masw.png'
import marker_remi from './static/Icons/icon_remi.png'
import marker_dh from './static/Icons/icon_dh.png'
import marker_ch from './static/Icons/icon_ch.png'
import marker_array from './static/Icons/icon_array.png'
import marker_sc from './static/Icons/center.png'
import marker_poz from './static/Icons/icon_pozzo.png'
import marker_sidr from './static/Icons/icon_idrocarburi.png'
import marker_off from './static/Icons/icon_soffshore.png'
import marker_din from './static/Icons/icon_din.png'
import marker_new_data from './static/Icons/new_data.png'
import marker_del_data from './static/Icons/remove.png'



const icon_new_data = new L.Icon({
    iconUrl: marker_new_data,
    iconRetinaUrl: marker_new_data,
    popupAnchor:  [-0, -0],
    iconSize: [30,30],
});


const myIconCPT = new L.Icon({
    iconUrl: marker_cpt,
    iconRetinaUrl: marker_cpt,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconCPTU = new L.Icon({
    iconUrl: marker_cptu,
    iconRetinaUrl: marker_cptu,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconCPTE = new L.Icon({
    iconUrl: marker_cpte,
    iconRetinaUrl: marker_cpte,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconDMT = new L.Icon({
    iconUrl: marker_dmt,
    iconRetinaUrl: marker_dmt,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconSDMT = new L.Icon({
    iconUrl: marker_sdmt,
    iconRetinaUrl: marker_sdmt,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconSONDAGGIO = new L.Icon({
    iconUrl: marker_sondaggio,
    iconRetinaUrl: marker_sondaggio,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconHVSR = new L.Icon({
    iconUrl: marker_hvsr,
    iconRetinaUrl: marker_hvsr,
    popupAnchor:  [-0, -0],
    iconSize: [15,15],
});

const myIconMASW = new L.Icon({
    iconUrl: marker_masw,
    iconRetinaUrl: marker_masw,
    popupAnchor:  [-0, -0],
    iconSize: [15,15],
});

const myIconDH= new L.Icon({
    iconUrl: marker_dh,
    iconRetinaUrl: marker_dh,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const icon = new L.Icon({
  iconSize: [80, 80],
  popupAnchor: [2, -40],
  iconUrl: marker_sc ,
});

const myIconPoz= new L.Icon({
    iconUrl: marker_poz,
    iconRetinaUrl: marker_poz,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconDin= new L.Icon({
    iconUrl: marker_din,
    iconRetinaUrl: marker_din,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconIdr= new L.Icon({
    iconUrl: marker_sidr,
    iconRetinaUrl: marker_sidr,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconOff= new L.Icon({
    iconUrl: marker_off,
    iconRetinaUrl: marker_off,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconCH= new L.Icon({
    iconUrl: marker_ch,
    iconRetinaUrl: marker_ch,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconArray= new L.Icon({
    iconUrl: marker_array,
    iconRetinaUrl: marker_array,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconRemi= new L.Icon({
    iconUrl: marker_remi,
    iconRetinaUrl: marker_remi,
    popupAnchor:  [-0, -0],
    iconSize: [20,20],
});

const myIconDelete= new L.Icon({
    iconUrl: marker_del_data,
    iconRetinaUrl: marker_del_data,
    popupAnchor:  [-0, -0],
    iconSize: [25,25],
});

export { myIconCPT, myIconCPTU,  myIconCPTE, myIconDMT, myIconSDMT, myIconSONDAGGIO, myIconHVSR,
myIconMASW, myIconDH, icon ,icon_new_data,myIconPoz,myIconDin,myIconIdr, myIconOff,myIconCH,myIconArray, myIconRemi,myIconDelete };